import { render, staticRenderFns } from "./PurchaseOrderView.vue?vue&type=template&id=35cab4d6"
import script from "./PurchaseOrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports